// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1639":"22faf5e6c1a4aab7","7773":"1cd2255691bace08","7973":"6abc73a4f7f7bda3"}[chunkId] + ".js";
};